import EmptyState from "Components/Common/EmptyState";
import Table, { type Column } from "../../../../Components/Table/Table";
import type { LogRow } from "../constants/changeOrderData";
import EmptyChangeOrderIcon from "Assets/Img/EmptyChangeOrderIcon";

interface CoLogTableProps {
  rows: LogRow[];
  onOpenRow: (row: LogRow) => void;
  readonly?: boolean;
}

const CoLogTable = ({ rows, onOpenRow, readonly = false }: CoLogTableProps) => {
  const columns: Column<LogRow>[] = [
    {
      header: "CO #",
      render: (row) => <span className="co-num">{row.id}</span>,
    },
    {
      header: "Project & Description",
      render: (row) => (
        <>
          <span className="coDesc">{row.description}</span>
          <br />
          <small className="coDescSub">{row.sub}</small>
        </>
      ),
    },
    { header: "Submitted", accessor: "submitted", className: "coDate" },
    {
      header: "Amount",
      render: (row) => (
        <span className={`co-amt ${row.amountTone}`.trim()}>{row.amount}</span>
      ),
    },
    { header: "Days Impact", accessor: "daysImpact", className: "coDate" },
    {
      header: "Status",
      render: (row) =>
        row.status ? (
          <span className={`badge ${row.statusClass}`.trim()}>
            <span className="dot" />
            {row.status}
          </span>
        ) : (
          <span>-</span>
        ),
    },
    {
      header: "",
      render: () => (
        <span className={`coLink ${readonly && "d-none"} `}>View →</span>
      ),
    },
  ];
  return (
    <div className="cologtableSec">
      <Table<LogRow>
        data={rows}
        columns={columns}
        onRowClick={onOpenRow}
        fallbackUI={
          <EmptyState
            noBorder={true}
            height={"100px"}
            icon={<EmptyChangeOrderIcon />}
            title="No Change Orders Yet"
            subtitle="Change orders will appear here once the GC submits them for review."
          />
        }
      />
    </div>
  );
};

export default CoLogTable;
